import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/i18n';
import App from './App.vue';
import router from './router';
import authGuard from './router/auth-guard';
import store from './store';
import HttpClient from './api/http-client';
import { Auth0Plugin } from './auth';
import './assets/styles/index.css';
import SentryLogger from './utils/logger/sentry';

Vue.use(VueI18n);
Vue.config.productionTip = false;

const i18n = new VueI18n({
    locale: 'es',
    fallbackLocale: 'en',
    messages,
});

Vue.use(Auth0Plugin, {
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
    audience: process.env.VUE_APP_AUTH0_AUDIENCE,
    scope: process.env.VUE_APP_AUTH0_SCOPE,
});

router.beforeEach(authGuard);

const logger = SentryLogger.fromVueInstance(Vue, router);

new Vue({
    i18n,
    provide: {
        httpClient: new HttpClient(logger),
        logger,
    },
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
